/**
 * Created by Florin David on 16/06/2017.
 */
import Action, { SET_UPDATE_IN_PROGRESS } from 'constants/action-types'

/**
 * Update in progress
 */
export default (state = false, action: Action): boolean => {
  switch (action.type) {
    case SET_UPDATE_IN_PROGRESS:
      return action.payload
    default:
      return state
  }
}
